import React from 'react';
import { CrmHero } from '../components/crm/CrmHero';
import { CrmProblems } from '../components/crm/CrmProblems';
import { CustomerJourney } from '../components/crm/CustomerJourney';
import { ReplaceApps } from '../components/crm/ReplaceApps';
import { WhyAdroiCrm } from '../components/crm/WhyAdroiCrm';
import { MobileAppSection } from '../components/crm/MobileAppSection';
import { CrmProof } from '../components/crm/CrmProof';
import { CrmFinalCta } from '../components/crm/CrmFinalCta';
import { ServiceFaq } from '../components/ServiceFaq';
import { crmPageFaqs } from '../data/faqs';
export function Crm() {
  return <>
      <CrmHero data-id="element-1190" data-mp="2aa5hhdq7pf52" />
      <CrmProblems data-id="element-1191" data-mp="2aap2x4f2mlnu" />
      <CustomerJourney data-id="element-1192" data-mp="2a718m31sxv82" />
      <ReplaceApps data-id="element-1193" data-mp="259rliu1vxvne" />
      <WhyAdroiCrm data-id="element-1194" data-mp="2599dz19rvv06" />
      <MobileAppSection data-id="element-1195" data-mp="258pyrsbibkpu" />
      <CrmProof data-id="element-1196" data-mp="25cnjgidqgkbu" />
      <ServiceFaq serviceName="CRM" faqs={crmPageFaqs} data-id="element-1197" data-mp="3loansddwe13k" />
      <CrmFinalCta data-id="element-1198" data-mp="3lmptmovhwk68" />
    </>;
}